var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationsGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.476,
    height: 28.133,
    viewBox: "0 0 22.476 28.133",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ios-notifications-outline",
    transform: "translate(-6.775 -3.93)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5539",
    "data-name": "Pfad 5539",
    d: "M20.37,28.336a.91.91,0,0,0-.893.717,1.752,1.752,0,0,1-.352.766,1.33,1.33,0,0,1-1.132.415,1.349,1.349,0,0,1-1.132-.415,1.768,1.768,0,0,1-.352-.766.915.915,0,1,0-1.786.4,3.143,3.143,0,0,0,3.27,2.609,3.137,3.137,0,0,0,3.27-2.609.92.92,0,0,0-.893-1.118Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5540",
    "data-name": "Pfad 5540",
    d: "M28.969,24.764c-1.083-1.427-3.213-2.264-3.213-8.655,0-6.56-2.9-9.2-5.6-9.83-.253-.063-.436-.148-.436-.415v-.2a1.725,1.725,0,0,0-1.688-1.73h-.042a1.725,1.725,0,0,0-1.688,1.73v.2c0,.26-.183.352-.436.415-2.707.64-5.6,3.27-5.6,9.83,0,6.391-2.13,7.221-3.213,8.655A1.4,1.4,0,0,0,8.177,27H27.872A1.4,1.4,0,0,0,28.969,24.764Zm-2.742.408H9.83a.308.308,0,0,1-.232-.513,8.538,8.538,0,0,0,1.477-2.348,15.935,15.935,0,0,0,1.005-6.2,10.776,10.776,0,0,1,1.47-6.1,4.513,4.513,0,0,1,2.721-1.941,2.471,2.471,0,0,0,1.308-.738.557.557,0,0,1,.837-.014,2.544,2.544,0,0,0,1.322.752,4.513,4.513,0,0,1,2.721,1.941,10.784,10.784,0,0,1,1.47,6.1,15.942,15.942,0,0,0,1,6.2A8.6,8.6,0,0,0,26.446,24.7a.291.291,0,0,1-.218.478Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsGrey);
export default __webpack_public_path__ + "static/media/notifications_grey.002850fadff399514b3c95eb64c7c267.svg";
export { ForwardRef as ReactComponent };